import { render, staticRenderFns } from "./StatsPaysVoyageurs.vue?vue&type=template&id=65986506&"
import script from "./StatsPaysVoyageurs.vue?vue&type=script&lang=js&"
export * from "./StatsPaysVoyageurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports